import { createSlice } from '@reduxjs/toolkit';
import {
  getPersons,
  addPerson,
  deletePerson,
  getPersonById,
  updatePerson,
  filterPersons,
  getPersonByType,
  importPersons,
  getAssignedPersons,
  getNotAssignedPersons,
  Unlinkdelegate,
  getArchivedPersons,
  restorePerson,
  getAllDoctorsForFilter,

  getDoctorVisitHistory 
} from './personsThunk';

const initialState = {
  persons: [],
  assignedPersons: { // <-- NOUVELLE PROPRIÉTÉ POUR LES DONNÉES ISOLÉES
    data: [],
    total: 0,
  },
  archivedPersons: {
    data: [],
    total: 0,
  },

  doctorVisits: { data: [], loading: false },

  doctorsForFilter: [], 

  person: null,
  loading: false,
  error: null,
};

const personsSlice = createSlice({
  name: 'persons',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPersons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPersons.fulfilled, (state, action) => {
        state.persons = action.payload;
        state.loading = false;
      })
      .addCase(getPersons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addPerson.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPerson.fulfilled, (state, action) => {
        state.person = true
        state.loading = false;
      })
      .addCase(addPerson.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deletePerson.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePerson.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deletePerson.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getPersonById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPersonById.fulfilled, (state, action) => {
        state.person = action.payload;
        state.loading = false;
      })
      .addCase(getPersonById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getPersonByType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPersonByType.fulfilled, (state, action) => {
        state.persons = action.payload;
        state.loading = false;
      })
      .addCase(getPersonByType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updatePerson.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePerson.fulfilled, (state, action) => {
        // state.persons = state.person?.map((person) =>
        //   person.id === action.payload.id ? action.payload : person
        // );
        state.loading = false;
      })
      .addCase(updatePerson.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(filterPersons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(filterPersons.fulfilled, (state, action) => {
        state.persons = action.payload;
        state.loading = false;
      })
      .addCase(filterPersons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(importPersons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(importPersons.fulfilled, (state, action) => {
        state.person = action.payload;
        state.loading = false;
      })
      .addCase(importPersons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       .addCase(getAssignedPersons.pending, (state) => {
        state.loading = true; // On peut garder un loading global
        state.error = null;
      })
      .addCase(getAssignedPersons.fulfilled, (state, action) => {
        // ON ÉCRIT DANS L'ÉTAT ISOLÉ !
        // action.payload est { data: [...], total: 100 }
        state.assignedPersons.data = action.payload.data; // On stocke le tableau
        state.assignedPersons.total = action.payload.total; // On stocke le total
        state.loading = false;
      })
      .addCase(getAssignedPersons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        // En cas d'erreur, on vide notre état isolé
        state.assignedPersons = { data: [], total: 0 };
      })      
      .addCase(getNotAssignedPersons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotAssignedPersons.fulfilled, (state, action) => {
        // La page "Assigner" peut continuer d'utiliser `state.persons`
        // action.payload est aussi { data: [...], total: ... }
        state.persons = action.payload; // <-- IMPORTANT : ici on stocke l'objet entier car la page "Assigner" est structurée comme ça
        state.loading = false;
      })
      .addCase(getNotAssignedPersons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(Unlinkdelegate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(Unlinkdelegate.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(Unlinkdelegate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getArchivedPersons.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getArchivedPersons.fulfilled, (state, action) => {
        state.loading = false;
        state.archivedPersons = action.payload;
      })
      .addCase(getArchivedPersons.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(restorePerson.pending, (state) => {
        // On pourrait utiliser un loading spécifique si on voulait
        state.loading = true; 
      })
      .addCase(restorePerson.fulfilled, (state, action) => {
        state.loading = false;
        // On retire la personne restaurée de la liste des archives
        state.archivedPersons.data = state.archivedPersons.data.filter(
          (p) => p.id !== action.payload
        );
        state.archivedPersons.total -= 1;
      })
      .addCase(restorePerson.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getAllDoctorsForFilter.pending, (state) => {
        // On ne met pas forcément loading=true global pour ne pas bloquer toute l'UI
      })
      .addCase(getAllDoctorsForFilter.fulfilled, (state, action) => {
        // L'API renvoie souvent { data: [...], total: ... } ou directement [...]
        // On s'assure de ne récupérer que le tableau
        state.doctorsForFilter = action.payload.data || action.payload; 
      })
      .addCase(getAllDoctorsForFilter.rejected, (state, action) => {
        console.error("Erreur chargement médecins filtre:", action.payload);
      })

      .addCase(getDoctorVisitHistory.pending, (state) => {
      state.doctorVisits.loading = true;
      })
      .addCase(getDoctorVisitHistory.fulfilled, (state, action) => {
          state.doctorVisits.loading = false;
          state.doctorVisits.data = action.payload;
      })
      .addCase(getDoctorVisitHistory.rejected, (state) => {
          state.doctorVisits.loading = false;
      });

      
  },
});

export default personsSlice.reducer;
